import { z } from 'zod';
import { BaseErrorSchema } from 'libs/end-to-end/src/types/errors/base-error-schema';

export const S3StorageListObjectsV2Error = BaseErrorSchema.extend({
  errorType: z.literal('S3StorageListObjectsV2Error'),
  bucketName: z.string(),
  bucketRegion: z.string(),
  sourcePrefix: z.string(),
  errorReason: z.string(),
});
